import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './DuplicateBlockControls.css';
import { getBlockDarkerColor } from '../../../helpers/color';
import Button from '../../atoms/Button/Button';
import { classnames } from '../../../helpers/classnames';
import useTranslate from '../../../hooks/useTranslate';

const DuplicateBlockControls = ({
  color,
  showIncrement = false,
  increment = 1,
  total = 1,
  onAddClick,
  onDelete,
  readonly = false,
  disabled = false,
}) => {
  const i18n = useTranslate();
  // Darken colors from background
  const borderColor = useMemo(() => getBlockDarkerColor(color, 0.5), [color]);
  const darkerColor = useMemo(() => getBlockDarkerColor(color), [color]);
  const deleteBtnBgColor = useMemo(() => getBlockDarkerColor(color, 1.2), [color]);

  // Disabled colors for buttons (also darken colors from background)
  const disabledBtnColor = useMemo(() => getBlockDarkerColor(color, 0.3), [color]);
  const disabledBtnBgColor = useMemo(() => getBlockDarkerColor(color, 0.7), [color]);

  return (
    <div className={styles.DuplicateBlockControls}>
      <div>
        {showIncrement && (
          <div
            className={styles.DuplicateBlockControls__increment}
            style={{ color: deleteBtnBgColor, border: `1px solid ${borderColor}` }}
          >
            {increment}/{total}
          </div>
        )}
      </div>
      <div
        className={styles.DuplicateBlockControls__rightBtns}
      >
        {onAddClick && (
          <Button
            type="button"
            icon="arrow_elbow_down_left"
            flat
            rounded
            title={i18n('BlockForm.insertAfter')}
            className={styles.DuplicateBlockControls__button}
            style={{
              fill: darkerColor,
              border: `1px solid ${borderColor}`,
              ...(readonly && { fill: disabledBtnColor }),
            }}
            onClick={onAddClick}
            disabled={readonly || disabled}
          />
        )}
        {onDelete && (
          <Button
            type="button"
            icon="close"
            flat
            rounded
            title={i18n('BlockForm.delete')}
            className={classnames([
              styles.DuplicateBlockControls__button,
              styles.DuplicateBlockControls__button__delete,
            ])}
            style={{
              '--btn-bg': deleteBtnBgColor,
              '--btn-hover-bg': darkerColor,
              ...(readonly && { '--btn-bg': disabledBtnBgColor }),
            }}
            onClick={onDelete}
            disabled={readonly || disabled}
          />
        )}
      </div>
    </div>
  );
};

DuplicateBlockControls.propTypes = {
  color: PropTypes.string.isRequired,
  showIncrement: PropTypes.bool,
  total: PropTypes.number,
  increment: PropTypes.number,
  onAddClick: PropTypes.func,
  onDelete: PropTypes.func,
  readonly: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default DuplicateBlockControls;
